import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import ResponsiveModal from '@components/ResponsiveModal';
import { MENU_SECTIONS_MAX_QUANTITY } from '@shopDetails/constants';
import theme from '@app/theme';
import SectionList from './components/SectionList';
import BottomSheet from './components/BottomSheet';
import CloseButton from './components/CloseButton';
import Container from './components/Container';
import Title from './components/Title';
import messages from './messages';

const customStyles = {
  overlay: {
    width: '100%',
    height: '100%',
    padding: 0,
    background: theme.colors.white,
  },
  closeButton: {
    left: '10px',
  },
  modal: {
    boxShadow: 'none',
    width: '100%',
  },
};

const MenuSection = ({
  open,
  onClose,
  sections,
  onClickSection,
  intl: { formatMessage },
}) => {
  if (sections.length >= MENU_SECTIONS_MAX_QUANTITY) {
    return (
      <ResponsiveModal styles={customStyles} open={open} onClose={onClose}>
        <Title isModal>{formatMessage(messages.menu)}</Title>
        <SectionList sections={sections} onClickSection={onClickSection} />
      </ResponsiveModal>
    );
  }

  return (
    <BottomSheet open={open} scrollEnabled={false} onClickOut={onClose}>
      <Container>
        <Title>{formatMessage(messages.menu)}</Title>
        <CloseButton onClick={onClose}>
          {formatMessage(messages.close)}
        </CloseButton>
        <SectionList sections={sections} onClickSection={onClickSection} />
      </Container>
    </BottomSheet>
  );
};

MenuSection.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  sections: PropTypes.array.isRequired,
  onClickSection: PropTypes.func.isRequired,
  intl: intlShape,
};

export default injectIntl(MenuSection);
